import { logger } from 'src/helpers/logger';
import type { RateLineSide } from '../../constants';
import type { IRateLine } from '../../sharedTypes';

export const headersCacheKey = (amendmentId: string | null | undefined, side: RateLineSide): string =>
  `${amendmentId ?? ''}/${side}`;

// Keyed by what makes a row unique rather than by `records[].id`, which the server does not promise to keep
// unique: unit × position × parity within a job type on either side.
export const rateLineRowKey = (row: IRateLine, side: RateLineSide): string => {
  // Both are required on the wire; a row without them would otherwise throw mid-render and blank the grid.
  if (!row.unit?.id || !row.position?.id) {
    logger.error(new Error(`[agencyContractsV2] rate line carries no unit or position: ${JSON.stringify(row)}`));
  }

  const unit = row.unit?.id ?? 'unknown';
  const position = row.position?.id ?? 'unknown';

  return `${side}/${unit}/${position}/${row.parity_status?.id ?? ''}/${row.job_type?.id ?? ''}`;
};
